import { deleteField, doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { SendAnalyticsEvent } from "../../../func/analyticsFunctions";

// Saves checklist progress on users/{uid}.subscribedRaces.{legId}.raceReady.
// Pass "now" for a timestamp and null to clear a value, e.g. { pictureAt: "now" } or { device: null }.
export function saveRaceReady(uid, legId, changes) {
  if (!uid || !legId) return Promise.resolve();
  const updates = {};
  Object.entries(changes).forEach(([key, value]) => {
    updates[`subscribedRaces.${legId}.raceReady.${key}`] = value === "now" ? serverTimestamp() : value === null ? deleteField() : value;
  });
  return updateDoc(doc(db, "users", uid), updates).catch((error) => console.error("Could not save race-ready progress", error));
}

export function trackRaceReady(eventName, params = {}) {
  try {
    SendAnalyticsEvent(eventName, params);
  } catch (error) {
    console.error("Could not send analytics event", error);
  }
}
